export default {
  emptyLanguage: ({ languages }) => languages.length == 0 
}